import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["actionId", "getHeaderTitle", "actionMetadata"];
import PropTypes from 'prop-types';
import AutomationBuilderCard from 'automation-ui-flow-core/canvas/AutomationBuilderCard';
import EnrollInFlowActionMetadata from 'automation-ui-action-features/actions/enroll-in-flow/records/EnrollInFlowActionMetadata';
import EnrollInFlowActionSummary from 'automation-ui-action-features/actions/enroll-in-flow/EnrollInFlowActionSummary';
import { jsx as _jsx } from "react/jsx-runtime";
function EnrollInFlowActionCard(_ref) {
  let {
      actionId,
      getHeaderTitle,
      actionMetadata
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(AutomationBuilderCard, Object.assign({}, rest, {
    headerTitle: getHeaderTitle({
      actionId
    }),
    content: /*#__PURE__*/_jsx(EnrollInFlowActionSummary, {
      metadata: actionMetadata
    })
  }));
}
EnrollInFlowActionCard.propTypes = {
  getHeaderTitle: PropTypes.func.isRequired,
  actionMetadata: PropTypes.instanceOf(EnrollInFlowActionMetadata).isRequired,
  actionId: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};
export default EnrollInFlowActionCard;